import { FC } from "react";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
import { ThemedTitle } from "@/canvas/layouts/ThemedBranding/ThemedTitle";
import { FormTypographyProps } from "@/forms-design-system/FormTypography/FormTypography";

type CampaignTitleProps = Omit<FormTypographyProps, "ref" | "variant" | "vibe" | "id" | "data-test" | "children">;

export const CampaignTitle: FC<CampaignTitleProps> = ({ ...rest }) => {
  const { localeField, formObject } = useFormV2Context();

  return (
    <ThemedTitle titleFontStyle={formObject.titleFontStyle} {...rest}>
      {localeField?.title}
    </ThemedTitle>
  );
};
